import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, AbstractControl } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DocumentTemplate } from 'src/app/shared/models/iCourrier/document-template';

@Component({
  selector: 'app-document-save-modal',
  templateUrl: './document-save-modal.component.html',
  styleUrls: ['./document-save-modal.component.scss'],
})
export class DocumentSaveModalComponent implements OnInit {
  public form: UntypedFormGroup;
  public selectedDocumentTpl: DocumentTemplate;
  public showDateLimite = false;
  public publipostageOK;
  constructor(
    private formbuilder: UntypedFormBuilder,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    if (this.config && this.config.data) {
      this.selectedDocumentTpl = this.config.data.selectedDocumentTpl;
      this.showDateLimite = this.config.data.showDateLimite;
      if (this.showDateLimite) {
        this.form = this.formbuilder.group({
          description: new UntypedFormControl('Document', [
            Validators.required,
            Validators.maxLength(200),
            Validators.pattern(/^[a-zA-ZÀ-ÖÙ-öù-ÿĀ-žḀ-ỿ0-9-()_' ]*$/),
          ]),
          dateLimite: new UntypedFormControl(null),
        });
      } else {
        this.form = this.formbuilder.group({
          description: new UntypedFormControl('Document', [
            Validators.required,
            Validators.maxLength(200),
            Validators.pattern(/^[a-zA-ZÀ-ÖÙ-öù-ÿĀ-žḀ-ỿ0-9-()_' ]*$/),
          ]),
        });
      }
      if (this.selectedDocumentTpl && this.selectedDocumentTpl.description && this.selectedDocumentTpl.description !== null) {
        if (this.selectedDocumentTpl.description.length > 200) {
          this.selectedDocumentTpl.description = this.selectedDocumentTpl.description.substring(0, 199);
        }
        this.f.description.patchValue(this.selectedDocumentTpl.description);
      }
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  onSubmit(): void {
    if (this.showDateLimite) {
      this.ref.close({ description: this.f.description.value, dateLimite: this.f.dateLimite.value });
    } else {
      this.ref.close(this.f.description.value);
    }
  }
}
